export default {
  'balanceAndTransactions.header': 'Balance & Transaction Reporting',
  'balanceAndTransactions.balanceReporting.balancesReflectAllAccounts':
    'These balances reflect all accounts'
};
